export const parseShortHandDate = (date) => {
  const monthMapping = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };

  const year = date.slice(0, 4);
  const month = monthMapping[date.slice(4, 6)];
  const day = date.slice(6, 8);
  return `${month} ${day}, ${year}`;
};
